import React from "react";
import Rating from "./Rating";
import { useUserOverallRatingQuery } from "../../reactWrapper/endpoints/talent/talent.api";

type Props = {
  talentId: string;
};

const OverallRating = ({ talentId }: Props) => {
  const { overallRating } = useUserOverallRatingQuery(talentId);

  return (
    <div className="">
      <h2 className="font-display text-xl lg:text-2xl font-semibold mb-1.5">
        Overall Rating
      </h2>
      <div className="grid grid-cols-2">
        <p>Work Quality</p>
        <Rating rating={overallRating?.code_quality ?? 0} />
        <p>Productivity</p>
        <Rating rating={overallRating?.productivity ?? 0} />
        <p className="whitespace-nowrap">Reliability</p>
        <Rating rating={overallRating?.reliability ?? 0} />
        <p>Communication</p>
        <Rating rating={overallRating?.communications ?? 0} />
        <p>Timelines</p>
        <Rating rating={overallRating?.timelines ?? 0} />
      </div>
    </div>
  );
};

export default OverallRating;
